import styled, { css } from 'styled-components';

export const SectionWrapper = styled.div(
  ({ theme }) => css`
    grid-area: review;

    padding: ${theme.sz.s8};
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: ${theme.sz.s3};
    background: ${theme.co.neutral98};
    border-radius: ${theme.bo.mediumLarger};
    box-shadow: 0 ${theme.sz.s1} 0 0 ${theme.co.secondary90};

    @media (max-width: ${theme.sz.lg}) {
      padding: ${theme.sz.s6};
    }
  `,
);

export const ReviewStars = styled.div(
  ({ theme }) => css`
    color: ${theme.co.primary20};
    display: flex;
    align-items: center;
    justify-content: first start;
    flex-direction: row;
    gap: ${theme.sz.s1};

    > * {
      width: ${theme.sz.s5};
      height: ${theme.sz.s5};
    }
  `,
);

export const ReviewText = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary0};
    ${theme.typography.paragraph.base};

    @media (min-width: ${theme.sz.xxl}) {
      ${theme.typography.paragraph.l};
    }
  `,
);

export const ReviewAuthor = styled.div(
  ({ theme }) => css`
    color: ${theme.co.neutral0};
    ${theme.typography.heading.mobile.xxs};

    @media (min-width: ${theme.sz.xl}) {
      ${theme.typography.heading.desktop.xxs}
    }
  `,
);
